import {
  FILTERS_UPDATED,
  HOME_TYPES_UPDATED,
  BAYS_UPDATED,
  FLOORS_UPDATED,
  QUICK_MOVE_IN_UPDATED,
  MPC_ONLY_UPDATED,
  RESET_CLICKED,
  DI_UPDATED,
  ASC_UPDATED,
  SORT_BY_UPDATED
} from '../actions/filters';
import { PRICE_RANGE_UPDATED } from '../actions/filters';
import { SQUARE_FEET_UPDATED } from '../actions/filters';
import { BRAND_UPDATED } from '../actions/filters';
import { BEDS_BATHS_UPDATED } from '../actions/filters';
import { qstr } from '../../util/urls';
import { getFiltersFromQs } from '../../util/filters';

const filters = (state = getFiltersFromQs(), action) => {
  switch (action.type) {
    case PRICE_RANGE_UPDATED:
      return Object.assign({}, state, {
        minPrice: action.minPrice,
        maxPrice: action.maxPrice
      });
    case SQUARE_FEET_UPDATED:
      return Object.assign({}, state, {
        minSquareFeet: action.minSquareFeet,
        maxSquareFeet: action.maxSquareFeet
      });
    case BRAND_UPDATED:
      return Object.assign({}, state, {
        brand: action.brand
      });
    case BEDS_BATHS_UPDATED:
      return Object.assign({}, state, {
        bedrooms: action.beds,
        bathrooms: action.baths
      });
    case HOME_TYPES_UPDATED:
      return Object.assign({}, state, {
        homeTypes: action.homeTypes
      });
    case BAYS_UPDATED:
      return Object.assign({}, state, {
        bays: action.bays
      });
    case FLOORS_UPDATED:
      return Object.assign({}, state, {
        floors: action.floors
      });
    case QUICK_MOVE_IN_UPDATED:
      return Object.assign({}, state, {
        quickMoveIn: action.quickMoveIn
      });
    case MPC_ONLY_UPDATED:
      return Object.assign({}, state, {
        mpcOnly: action.mpcOnly
      });
    case FILTERS_UPDATED:
      return Object.assign({}, state, {
        timeStamp: new Date().getTime()
      });
    case RESET_CLICKED:
      return Object.assign({}, state, {
        resetTimeStamp: new Date().getTime()
      });
    case DI_UPDATED:
      return Object.assign({}, state, {
        di: action.di
      });
    case ASC_UPDATED:
      return Object.assign({}, state, {
        asc: action.asc
      });
    case SORT_BY_UPDATED:
      return Object.assign({}, state, {
        sortBy: action.sortBy
      });
    default:
      return state;
  }
};

export default filters;
